var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOptician(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.063,6l-0.25,0.656l-3.5,9.344l-1.313,0l0,2l1,0l0,2c0,3.297 2.703,6 6,6l2,0c3.297,0 6,-2.703 6,-6l0,-3c0,-0.566 0.434,-1 1,-1c0.566,0 1,0.434 1,1l0,3c0,3.297 2.703,6 6,6l2,0c3.297,0 6,-2.703 6,-6l0,-2l1,0l0,-2l-1.313,0l-3.5,-9.344l-0.25,-0.656l-1.937,0l-0.281,0.375l-2.5,3l1.562,1.25l1.906,-2.313l2.875,7.688l-9.75,0c-0.417,-1.156 -1.519,-2 -2.812,-2c-1.293,0 -2.395,0.844 -2.813,2l-9.75,0l2.876,-7.688l1.906,2.313l1.562,-1.25l-2.5,-3l-0.281,-0.375l-1.937,0Z",
    style: {
      fillRule: "nonzero"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptician);
export default __webpack_public_path__ + "static/media/optician.adfe8e0c4dad7ec1cdf72b8c12d51823.svg";
export { ForwardRef as ReactComponent };